import {map} from 'lodash-es'
import {transparentize} from 'polished'
import {createGlobalStyle, css} from 'styled-components'
import {normalize} from 'styled-normalize'
import media from '../utils/media'
import theme from './theme'
import typography from './typography'

export default createGlobalStyle`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
    margin: 0;
  }

  /* stylelint-disable */
  ${normalize}
  /* stylelint-enable */

  @font-face {
    font-family: "Open Sans-fallback";
    src: local("Arial");
    ascent-override:101.18%;
    descent-override:27.73%;
    line-gap-override:0.00%;
    size-adjust:105.64%
  }

  :root {
    scroll-behavior: auto;
    /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
    font-family: ${theme.fonts.family}, "Open Sans-fallback";
    font-size: ${theme.responsive.zoom.fontSizeBase}px;
    ${media.down(theme.responsive.zoom.minimalViewport)(css`
      font-size: ${(theme.responsive.zoom.fontSizeBase / theme.responsive.zoom.minimalViewport) * 100}vw;
    `)}
  }

  html {
    overflow-x: hidden;
  }

  body {
    background-color: ${theme.colors.background};
    overflow-x: hidden;
    color: ${theme.colors.text};
  }

  a {
    text-decoration: none;
    color: ${theme.colors.text};
    &:hover,
    &:focus {
      outline: none;
    }

    &[href^="mailto"],
    &[href^="tel"] {
      text-decoration: underline;
    }
  }

  button {
    &:hover,
    &:focus {
      outline: none;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }

  p:not(:first-child) {
    margin-block: ${({theme}) => theme.spacer} 0;
  }

  hr {
    margin: 0 -0.5rem;
    border-color: ${({theme}) => transparentize(0.73, theme.colors.text)};
  }

  .text-color {
    ${({theme}) =>
      map(theme.colors, (color, key) => {
        return css`
          &-${key} {
            color: ${color};
          }
        `
      })}
  }

  .sr-only {
    position: absolute;
    margin: -1px;
    border: 0;
    clip-path: inset(50%);
    padding: 0;
    width: 1px;
    height: 1px;
    overflow: hidden;
    white-space: nowrap;
  }

  .text-underline {
    text-decoration: underline;
  }

  ${typography}
`
